/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/campaign_stats" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdCampaignStats } from "./constants";
import type { EmailIpWarmingCampaignStatsResult, EmailIpWarmingCampaignStatsResultErrors } from "./types";
import { isEmailIpWarmingCampaignStatsResult } from "./validators";

export const getEmailIpWarmingCampaignStats = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdCampaignStats,
  createGetFetcherFunctionWithShadowError<EmailIpWarmingCampaignStatsResultErrors>()(
    (signal: AbortSignal, appGroupId: string): Promise<EmailIpWarmingCampaignStatsResult> => {
      return fetch(`/email/ip_warming/${appGroupId}/campaign_stats`, "GET", {}, { signal });
    }
  ),
  isEmailIpWarmingCampaignStatsResult
);
